import React from 'react';
import {useOutlet} from 'reconnect.js';
import {graphql, useStaticQuery} from 'gatsby';
import {getAdminRoutes} from '../Utils/CustomAdminLayout';
import {sliceTailSlash} from '../Utils/NavUtil';
import * as JStorage from '../JStorage';

function findNamebyPath(routes, path) {
  let parentName = '';
  function dfs(nodes) {
    for (let node of nodes) {
      if (Array.isArray(node['subroutes'])) {
        let childName = dfs(node['subroutes']);
        if (childName) {
          parentName = node.name;
          return childName;
        }
      }
      let nodePath = node.path ?? '';
      const endIdx = nodePath.indexOf('?');
      if (endIdx > -1) {
        nodePath = nodePath.slice(0, endIdx);
      }
      if (sliceTailSlash(nodePath) === sliceTailSlash(path)) {
        return node.name;
      }
    }
  }
  let childName = dfs(routes, path);
  return childName ? {name: childName, parentName} : null;
}

export default function useRouteChange({location = {pathname: '/'}}) {
  const [user] = useOutlet('user');

  // const adminPages = useStaticQuery(graphql`
  //   query MyQuery {
  //     allAdminJson {
  //       edges {
  //         node {
  //           name
  //           path
  //           collection
  //         }
  //       }
  //     }
  //   }
  // `);

  React.useEffect(() => {
    if (user && process.env.NODE_ENV === 'production') {
      if (location.pathname.indexOf('/admin/') > -1) {
        // admin
        async function logAdmin() {
          try {
            const routes = getAdminRoutes();
            let names = findNamebyPath(routes, location.pathname);
            if (names) {
              await JStorage.createDocument('admin_usage_history', {
                owner: user.sub,
                username: user.ext?.username,
                name: user.data?.name,
                created: new Date().getTime(),
                ...(names.name
                  ? {model: names.parentName, detail: names.name}
                  : {model: names.name}),
              });
            }
          } catch (e) {
            console.warn('log history error', e);
          }
        }

        logAdmin();
      } else if (location.pathname.indexOf('/app/') === -1) {
        // web
      }
    }
  }, [location.pathname, user]);
}
